import { render, staticRenderFns } from "./StudentSubjectList.vue?vue&type=template&id=d7e7fb98&"
import script from "./StudentSubjectList.vue?vue&type=script&lang=ts&"
export * from "./StudentSubjectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports